import { authenticatedFetch } from "./base";

export const fetchProms = () => {
  return authenticatedFetch(`/api/proms`, { method: "get" })
    .then(function (response) {
      if (response.status === 200) {
        return response.json();
      }
    })
    .then(function (prom) {
      return prom;
    });
};
